import m from 'mithril';
import { InitialConfigurationData } from '../../Models';
import { Fsm } from 'little-fsm';
import { AppComponents } from '../../app_common_setup';
import HomePage from '../../components/desktop/home/HomePage';
import { DesktopManifiest } from '../../states/app_desktop_root';

export function buildHomePresenter(fsm:Fsm<DesktopManifiest>, appComponents:AppComponents, initialConfigData:InitialConfigurationData,
    extraContentTemplateId:string|null
): {render:() => m.Vnode<any, any>} {
    let messageProvider = appComponents.messageProvider;
    let bannerImageUrl = appComponents.branding.bannerImageUrl;

    return {
        render() {
            return m(HomePage, {
                hotelSearchFormState: fsm.getCurrentStateContext('home').hotelSearchFormState,
                locations: initialConfigData.locations,
                bannerImageUrl: bannerImageUrl || "",
                messageProvider : messageProvider,
                extraContentTemplateId: extraContentTemplateId,
                onSearch : function(searchCriteria){
                    fsm.processEvent('search_submitted', {
                        searchCriteria: searchCriteria
                    })
                }
            })
        }
    }
}